import React from 'react';
import { Link } from 'react-router-dom';

// import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me2.jpg`} alt="" />
      </Link>
      <header>
        <h2>Junjie Xiong</h2>
        <p1 style={{ fontFamily: 'Raleway, Helvetica, sans-serif' }}>Department of Computer Science,</p1><br />
        <p1 style={{ fontFamily: 'Raleway, Helvetica, sans-serif' }}>Missouri S&T</p1><br />
        <p1 style={{ fontFamily: 'Raleway, Helvetica, sans-serif' }}>500 W. 15th St. CS Building 316</p1>
        <br />
        <p1 style={{ fontFamily: 'Raleway, Helvetica, sans-serif' }}>Email: <a href="mailto:Junjiexiong@mst.edu">Junjiexiong@mst.edu</a></p1>
      </header>
    </section>
  </section>
);

export default SideBar;
